import React, { memo } from 'react';
import colors from 'styles/themes/colors';

/**
 * Border renders an SVG line element, passing the props as presentational attributes.
 * The stroke will not scale in a transformed group and has a light grey default color.
 *
 * @param {String} props.stroke The stroke color
 * @param {String} props.strokeWidth The stroke width
 */

interface IBorderProps {
  stroke?: string;
  strokeWidth?: number;
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

const Border: React.FC<IBorderProps> = memo(
  (props: IBorderProps): JSX.Element => (
    <line
      {...{
        ...props,
        stroke: props.stroke || colors.LightGrey,
        strokeWidth: props.strokeWidth || 2,
      }}
      vectorEffect="non-scaling-stroke"
    />
  )
);
Border.displayName = 'BorderMemoLine';

export default memo(Border);
